import { render, staticRenderFns } from "./productCode.vue?vue&type=template&id=244e6212"
import script from "./productCode.vue?vue&type=script&lang=js"
export * from "./productCode.vue?vue&type=script&lang=js"
import style0 from "./productCode.vue?vue&type=style&index=0&id=244e6212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports